/**
 * Identity matrix
 * @returns {Matrix} Affine Matrix
 */
export function identity () {
  return {
    a: 1,
    c: 0,
    e: 0,
    b: 0,
    d: 1,
    f: 0
  }
}
